import React, { Component } from 'react';

import Icon from '../../../../components/Icon';
import './styles.css';

class Filter extends Component {
  render() {
    const {
      isOpen,
      label,
      className,
      children,
      alignDropdownRight,
      onClick,
    } = this.props;

    return (
      <div className={`OperationalDashboard__Filter ${(className || '')}${isOpen ? ' OperationalDashboard__Filter--open' : ''}`} >
        <div className="OperationalDashboard__Handle" onClick={onClick}>
          <span className="OperationalDashboard__Filter_Handle-desc">{label}</span>
          <Icon
            className="OperationalDashboard__Filter_Handle-icon"
            name="arrow_drop_down"
          />
        </div>
        <div className={`OperationalDashboard__Filter__Dropdown${alignDropdownRight ? ' OperationalDashboard__Filter__Dropdown--align-right' : ''}`}>
          { isOpen && children }
        </div>
      </div>
    );
  }
}

export default Filter;
